module.exports = __webpack_public_path__ + "static/img/logo_symappsys.8a4acd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_symappsys.png
// module id = 955W
// module chunks = 0